import { observable, action } from 'mobx'

export default class {
  @observable showPanel = false
  @observable showModal = false
  @observable modalLink = ''

  @action
  changePanelState = (status, index) => {
    this.showPanel = {
      status,
      index
    }
  }

  @action
  onPreview = path => {
    this.modalLink = path
    this.showModal = true
  }

  @action
  onCancel = () => {
    this.showModal = false
  }
}
